<app-preloader *ngIf="isLoading"></app-preloader>

<div class="amortizations inTab" id="amortizations">
  <div class="accordionWrapper">
    <div>
      <div class="mainWrapper">
        <div class="amortizationsCards">
          <!-- Tabla para amortizaciones -->
          @if (filterPayments().total !== 0) {
            @if (filterPayments().items[currentPage() - 1]; as item) {
              <div class="card">
                <div class="period">
                  <div class="header">
                    <h3>
                      <span class="type">Nº </span>{{ item?.period }} / {{ filterPayments().total }}
                      <span class="type">Mes </span>{{ formatDate(item?.paymentDate) }}
                    </h3>
                  </div>
                  <div class="row">
                    <span>Tipo de pago</span>
                    <span>{{ getPaymentType(item?.paymentType) }}</span>
                  </div>
                </div>
                @if (quantity > 1) {
                  <div class="unit">
                    <div class="header">
                      <h3>Unidad</h3>
                    </div>
                    <div class="row">
                      <span>Saldo</span>
                      <span>{{ item?.capitalBalance | currency: '' : '' }}</span>
                    </div>
                    <div class="row">
                      <span>Intereses</span>
                      <span>{{ item?.interest | currency: '' : '' }}</span>
                    </div>
                    <div class="row">
                      <span>Capital</span>
                      <span>{{ item?.capitalPayment | currency: '' : '' }}</span>
                    </div>
                    <div class="row">
                      <span>
                        @if (isFinancialLeasing()) {
                          IVA de capital
                        } @else {
                          IVA
                        }
                      </span>
                      <span>{{ item?.interestTax | currency: '' : '' }}</span>
                    </div>
                    <div class="row total">
                      <span>Total</span>
                      <span>{{ item?.total | currency: '' : '' }}</span>
                    </div>
                  </div>
                }
                <div class="total">
                  <div class="header">
                    <h3>Total ({{ quantity != 0 ? quantity : '' }} unidades)</h3>
                  </div>
                  <div class="row">
                    <span>Saldo</span>
                    <span>{{ item.capitalBalance * quantity | currency: '' : '' }}</span>
                  </div>
                  <div class="row">
                    <span>Intereses</span>
                    <span>{{ item.interest * quantity | currency: '' : '' }}</span>
                  </div>
                  <div class="row">
                    <span>Capital</span>
                    <span>{{ item.capitalBalance * quantity | currency: '' : '' }}</span>
                  </div>
                  <div class="row">
                    <span>
                      @if (isFinancialLeasing()) {
                        IVA de capital
                      } @else {
                        IVA
                      }
                    </span>
                    <span>{{ item.interestTax * quantity | currency: '' : '' }}</span>
                  </div>
                  <div class="row total">
                    <span>Total</span>
                    <span>{{ item.total * quantity | currency: '' : '' }}</span>
                  </div>
                </div>
              </div>
            }
          } @else {
            <!-- Si la tabla está vacía mostra el div.noData -->
            <div class="noData" *ngIf="payments.length <= 0">No hay información disponible</div>
          }
          <div class="amortizationsTable" *ngIf="filterPayments().total > 0">
            <app-custom-paginator
              [totalPages]="filterPayments().total"
              [specialPages]="filterPayments().specialPages"
              [currentPage]="currentPage()"
              (pageChange)="onChangePage($event)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <ng-template #specialTemplate>
  <app-grace-special-payments
    [period]="period"
    [idQuote]="idQuote"
    [idDeal]="idDeal"
    (newPayment)="update($event)"
    (deletePayment)="delete($event)"
  ></app-grace-special-payments>
</ng-template> -->
